<template>
  <section>
    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <div>
              <el-tooltip content="Back" placement="bottom">
                <base-button
                  type="neutral"
                  class="btn-icon-only"
                  @click="goToPreviousPage()"
                >
                  <i class="flaticon-left-1"></i>
                </base-button>
              </el-tooltip>
            </div>
            <div>
              <h1 class="title-view">
                {{ $route.meta.title }}
              </h1>

              <div class="box-id">
                <div class="status-tab">
                  <div
                    class="badge-status text-status d-inline-flex align-items-center"
                    v-bind:class="getClassByDocumentStatus(document.status)"
                  >
                    {{ getStatusFormat(document.status) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-12 alinmov2">
          <div class="box-buttons">
            <a
              :href="gotToDocument(document)"
              target="_blank"
              class="btn min-button mr-2 btn-outline-neutral d-inline-flex align-items-center"
              v-if="
                document.status === 'PUBLISHED' && document.app === 'INTERNAL'
              "
              ><i class="flaticon-view-1 icon-no-margin"></i
              ><strong class="d-lg-block d-none">See in Help</strong>
            </a>

            <base-button
              type="outline-neutral"
              class="min-button  mr-2"
              v-clipboard:copy="getAbsoluteUrl(document)"
              v-clipboard:success="onCopy"
              v-clipboard:error="onErrorCopy"
            >
              <i class="flaticon-copy icon-no-margin"></i>
              <strong class="d-lg-block d-none">Copy Url</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              class="min-button mr-2"
              @click="mode = 'view'"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button"
              v-if="mode === 'view'"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              @click="updateDocument()"
              class="min-button"
              v-if="mode === 'edit'"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <tabs
        tabNavClasses="tabs-home justify-content-around tab-profiles"
        :value="tabActive"
        @changeTabActive="changeTabActive"
        type="primary"
      >
        <tab-pane
          class="tabs-home-content"
          id="Overview"
          title="Overview"
          ref="Overview"
        >
          <div class="row">
            <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="row" v-if="mode === 'edit'">
                <div class="col-xl-12">
                  <div
                    class="card"
                    v-bind:class="{
                      'invalid-card': $v.document.images.$error
                    }"
                  >
                    <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                      <label
                        for="insuranceCard"
                        class="title-label-np"
                        v-bind:class="{
                          'is-invalid': $v.document.images.$error
                        }"
                      >
                        <span class="markrequired">*</span>Cover Image
                        <el-popover
                          placement="top"
                          trigger="hover"
                          width="300"
                          class="curp"
                        >
                          <ul class="ul-pop">
                            <li>Allowed Dimensions: 780 x 420 px</li>
                            <li>Maximum Size: 2MB</li>
                            <li>Allowed Formats: GIF,JPG,JPEG,PNG</li>
                          </ul>
                          <div class="badge badge-primary" slot="reference">
                            <span>?</span>
                          </div>
                        </el-popover>
                      </label>
                      <div>
                        <div class="imageload2">
                          <div class="image">
                            <div
                              v-if="imagePreview"
                              v-bind:style="{
                                backgroundImage: 'url(' + imagePreview + ')'
                              }"
                              class="imgLogoIcon"
                            ></div>
                            <div
                              v-else
                              v-bind:style="{
                                backgroundImage: 'url(' + imageDefault + ')'
                              }"
                              class="imgLogoIcon"
                            ></div>
                          </div>
                          <div class="contentfile2">
                            <base-dropdown menuOnRight>
                              <base-button
                                slot="title-container"
                                type="primary"
                                class="dropdown-toggle btn-icon-only buttonfiles2"
                              >
                                <i class="flaticon-camera m-0"></i>
                              </base-button>
                              <span class="dropdown-item">
                                <base-input
                                  class="filebutton2"
                                  type="file"
                                  name="imagepreview2"
                                  id="imagepreview2"
                                  accesskey="insurance"
                                  enctype="multipart/form-data"
                                  accept="image/jpeg, image/jpg, image/png"
                                  @change="uploadFile"
                                ></base-input
                                >Upload Image
                              </span>
                              <span
                                class="dropdown-item"
                                v-if="imagePreview"
                                @click="clearfile()"
                                >Remove</span
                              >
                            </base-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="$v.document.images.$error"
                    class="invalid-feedback mb-2"
                  >
                    Select a cover image
                  </div>
                </div>

                <div class="col-xl-12">
                  <div class="card">
                    <div class="row">
                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                        <WSelect
                          filterable
                          remote
                          placeholder="Select a Status"
                          v-model.trim="document.status"
                          id="status_search"
                          name="status_search"
                          label="Status"
                          clearable
                          markrequired
                        >
                          <el-option
                            v-for="(item, index) in status"
                            class="select-danger"
                            :value="item.value"
                            :label="`${item.label}`"
                            :key="index"
                          ></el-option>
                        </WSelect>
                      </div>

                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                        <base-input
                          v-model="publicationDate"
                          label="Last Updated"
                          placeholder="Date"
                          id="date"
                          name="date"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-if="mode === 'view'">
                <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                  <div class="card">
                    <div
                      class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12 mb-4"
                    >
                      <div class="data-block">
                        <span class="title-block">Cover Image</span>
                      </div>

                      <img :src="imagePreview" alt="image" class="img-fluid" />
                    </div>
                  </div>
                </div>
                <div class="col-xl-12">
                  <div class="card">
                    <div class="row">
                      <div class="col-12">
                        <div class="data-block">
                          <span class="title-block">Last Updated</span>
                          <span class="content-block capitalize">{{
                            publicationDate
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
              <div class="card">
                <h2 class="subtitle">Parameters</h2>
                <div class="row" v-if="mode === 'edit'">
                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 option-transfers"
                  >
                    <div class="data-block">
                      <span class="title-block">Type Document</span>
                      <span class="content-block capitalize">{{
                        getTypeFormat(document.type)
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0 mt-3"
                  >
                    <WSelect
                      filterable
                      remote
                      placeholder="Select an App"
                      v-model.trim="document.app"
                      id="app_filter"
                      name="app_filter"
                      label="App"
                      clearable
                      :error="$v.document.app.$error ? `Select an App` : ''"
                      :disabled="document.type === 'RELEASE'"
                      markrequired
                    >
                      <el-option
                        v-for="(item, index) in apps"
                        class="select-danger"
                        :value="item.value"
                        :label="`${item.name}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 "
                    v-if="document.type != 'RELEASE'"
                  >
                    <WSelect
                      filterable
                      remote
                      reserve-keyword
                      placeholder="Select a Module"
                      v-model.trim="document.module"
                      id="modules_search"
                      name="modules_search"
                      label="Module"
                      clearable
                      markrequired
                      :error="
                        $v.document.module.$error ? `Select a Module` : ''
                      "
                    >
                      <el-option
                        v-for="(item, index) in modules"
                        class="select-danger"
                        :value="item.value"
                        :label="`${item.name}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 option-transfers"
                  >
                    <div class="data-block">
                      <span class="title-block">Type Document</span>
                      <span class="content-block capitalize">{{
                        getTypeFormat(document.type)
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-0 mt-3"
                  >
                    <div class="data-block">
                      <span class="title-block">App</span>
                      <span class="content-block capitalize">{{
                        getAppFormat(document.app)
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-4 col-lg-4 col-md-6 col-sm-6 "
                    v-if="document.type != 'RELEASE'"
                  >
                    <div class="data-block">
                      <span class="title-block">Module</span>
                      <span class="content-block capitalize">{{
                        getModuleFormat(document.module)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card" v-if="document.type === 'RELEASE'">
                <h2 class="subtitle">Release</h2>
                <div class="row" v-if="mode === 'edit'">
                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <WSelect
                      filterable
                      remote
                      placeholder="Select a release type"
                      v-model.trim="document.release.type"
                      id="releasetype"
                      name="releasetype"
                      label="Type"
                      clearable
                      @change="
                        changeVersion(document.release.type, release.version)
                      "
                      :disabled="document.type === 'RELEASE'"
                      markrequired
                      :error="
                        $v.document.release.type.$error ? `Select a Type` : ''
                      "
                    >
                      <el-option
                        v-for="(item, index) in releaseTypes"
                        class="select-danger"
                        :value="item.value"
                        :label="`${item.label}`"
                        :key="index"
                      ></el-option>
                    </WSelect>
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model="$v.document.release.version.$model"
                      label="Version"
                      placeholder="Version"
                      id="version"
                      name="version"
                      disabled
                    />
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Release Type</span>
                      <span class="content-block capitalize">{{
                        document.release.type
                      }}</span>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="data-block">
                      <span class="title-block">Release Version</span>
                      <span class="content-block capitalize">{{
                        document.release.version
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card">
                <h2 class="subtitle">Details</h2>
                <div class="row" v-if="mode === 'edit'">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"
                    v-bind:class="{
                      'is-invalid': $v.document.title.$error
                    }"
                  >
                    <label class="title-label">
                      <span class="markrequired">*</span>Name | Title
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          It's the name that identifies the document. This name
                          is taken as the Meta Title of the document. Must be
                          unique.
                          <br />
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover>
                    </label>
                    <el-input
                      v-model="$v.document.title.$model"
                      placeholder="Document title"
                      id="document_title"
                      name="document_title"
                      @input="createDocumentSlug"
                      maxlength="160"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 2 }"
                      show-word-limit
                      autofocus
                    >
                    </el-input>

                    <div
                      v-if="$v.document.title.$error"
                      class="invalid-feedback mb-0 mt--1"
                    >
                      {{ validationMessageForDocumentName($v.document.title) }}
                    </div>
                  </div>

                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"
                    v-bind:class="{
                      'is-invalid': $v.document.short_description.$error
                    }"
                  >
                    <label
                      slot="label"
                      for="document_short_description"
                      class="title-label"
                      ><span class="markrequired">*</span>Short Description
                      <el-popover
                        placement="bottom"
                        trigger="hover"
                        width="350"
                        class="curp"
                      >
                        <span>
                          Add a short description of the Document
                        </span>
                        <div class="badge badge-primary" slot="reference">
                          ?
                        </div>
                      </el-popover></label
                    >

                    <el-input
                      v-model="$v.document.short_description.$model"
                      placeholder="Document short_description"
                      id="document_short_description"
                      name="document_short_description"
                      tabindex="15"
                      maxlength="160"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 2 }"
                      show-word-limit
                    >
                    </el-input>

                    <div
                      v-if="$v.document.short_description.$error"
                      class="invalid-feedback mt--1"
                    >
                      {{
                        $v.document.short_description.$error
                          ? `Enter from ${$v.document.short_description.$params.minLength.min} to ${$v.document.short_description.$params.maxLenght.max} characters.`
                          : ""
                      }}
                    </div>
                  </div>
                </div>

                <div class="row" v-if="mode === 'view'">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="data-block">
                      <span class="title-block">Title</span>
                      <span class="content-block capitalize">{{
                        document.title
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                  >
                    <div class="data-block">
                      <span class="title-block">Short Description</span>
                      <span class="content-block capitalize">{{
                        document.short_description
                      }}</span>
                    </div>
                  </div>

                  <!-- <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                  >
                    <div class="data-block">
                      <span class="title-block">Url</span>
                      <span class="content-block capitalize">{{
                        document.slug
                      }}</span>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </tab-pane>

        <tab-pane
          class="tabs-home-content"
          id="Content"
          title="Content"
          ref="Content"
        >
          <div class="row" v-if="mode === 'edit'">
            <div class="col-xl-12">
              <div class="card pb-4">
                <h2
                  class="subtitle mb-2"
                  v-bind:class="{
                    'is-invalid': $v.document.content.$error
                  }"
                >
                  <span class="markrequired">*</span>Content
                  <el-popover
                    placement="bottom"
                    trigger="hover"
                    width="350"
                    class="curp"
                  >
                    <span>
                      Add a content as it will be a part of the document.
                    </span>
                    <div class="badge badge-primary" slot="reference">
                      ?
                    </div>
                  </el-popover>
                </h2>
                <div class="row">
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                    v-bind:class="{
                      'is-invalid': $v.document.content.$error
                    }"
                  >
                    <vue-editor
                      v-model="document.content"
                      id="editordocument"
                      ref="myEditor"
                      @ready="onEditorReady"
                    />
                    <div
                      v-if="$v.document.content.$error"
                      class="invalid-feedback mt--1"
                    >
                      Enter 200 to 20000 characters
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="mode === 'view'">
            <div class="col-xl-12">
              <h2 class="subtitle mb-2">
                Content
              </h2>
              <div class="card pb-4">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="articles" v-html="document.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </tab-pane>
      </tabs>

      <div></div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { DocumentsAPI } from "../../../../../core/api";
import flatPicker from "vue-flatpickr-component";
import lodash from "lodash";
import "flatpickr/dist/flatpickr.css";
import { Switch, Card, DatePicker } from "element-ui";
import Swal from "sweetalert2";
import { VueEditor } from "vue2-editor";
import { APPS, MODULES } from "../../../../../core/constants";
import moment from "moment-timezone";
import {
  required,
  minLength,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
import { goBack, setSigOut } from "../../../../../helpers/commons.helpers";
import { FileService } from "../../../../../core/services";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "DocumentProfile",
  data() {
    return {
      document: {
        type: "",
        app: "",
        module: "",
        title: "",
        slug: "",
        status: "",
        short_description: "",
        content: "",
        date: moment().format(),
        images: "",
        release: {
          type: "",
          version: ""
        }
      },
      status: [
        {
          label: "Draft",
          value: "DRAFT",
          icon: "status-draft"
        },
        {
          label: "In Revision",
          value: "REVISION",
          icon: "text-warning"
        },
        {
          label: "Approved",
          value: "APPROVED",
          icon: "text-new"
        },
        {
          label: "Published",
          value: "PUBLISHED",
          icon: "text-success"
        }
      ],
      apps: APPS,
      modules: MODULES,
      imageDefault: require("rhomtrip_assets/src/img/no-preview.png"),
      imagePreview: null,
      releaseTypes: [
        {
          label: "Major",
          value: "MAJOR"
        },
        {
          label: "Medium",
          value: "MEDIUM"
        },
        {
          label: "Minimum",
          value: "MINIMUM"
        }
      ],
      tabActive: "Overview",
      documentCopy: {},
      publicationDate: "",
      onSave: false,
      mode: "view",
      edit: true,
      documentId: null,
      lastSlug: "",
      release: {
        type: "MINIMUM",
        version: "0.0.0",
        app: ""
      },
      oldStatus: ""
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },
      {
        text: "Documentation",
        to: "/tools/documentation"
      },
      {
        text: "Document",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.documentId = this.$route.params.id;
    this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
    await this.getDocumentById(this.documentId);
  },
  methods: {
    async getDocumentById(documentId) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.getDocumentById(
          documentId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let document = data.data;
          this.document.type = document.type;
          this.document.app = document.app;
          this.document.module = document.module;
          this.document.title = document.title;
          this.$v.document.title.$model = document.title;
          this.document.slug = document.slug;
          this.lastSlug = document.slug;
          this.document.status = document.status;
          this.oldStatus = document.status;
          this.document.short_description = document.short_description;
          this.document.content = document.content;
          this.document.images = document.images;
          [this.imagePreview] = document.images;
          this.document.release = document.release;
          this.publicationDate = moment(document.date).format(
            "DD MMM. YYYY - hh:mm A"
          );
          this.documentCopy = lodash.cloneDeep(this.document);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async saveDocument(route = null) {
      if (!this.$v.document.$invalid) {
        let document = lodash.cloneDeep(this.document);
        document.date = moment().format();
        await this.updateDocumentById(this.documentId, document, route);
      } else {
        this.$v.document.$touch();
        let tab = this.getTabByInvalidDocumentData(this.$v.document);
        this.changeTabActive(tab);
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateDocumentById(documentId, document, route = null) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.updateDocumentById(
          documentId,
          document,
          this.sesion.token
        );
        this.setLoad(false);
        this.onSave = true;
        if (data.status) {
          let { document } = data.data;
          this.oldStatus = document.status;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Document has been Saved",
            icon: "flaticon-check-mark"
          });
          if (route) {
            this.$router.push(route);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.onSave = true;
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    createDocumentSlug(title) {
      this.document.slug = this.createSlug(title.trim());
    },
    createSlug(title = "") {
      return title
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");
    },
    async checkDocumentSlugIsDuplicate(slug, app) {
      try {
        let { data } = await DocumentsAPI.checkDocumentSlugIsDuplicate(
          slug,
          app,
          this.sesion.token
        );
        return data.status ? !data.data.isDuplicate : false;
      } catch (error) {
        return false;
      }
    },
    validationMessageForDocumentName(name) {
      if (name.$error) {
        if (!name.required) {
          return "Enter the document title";
        } else if (!name.minLength || !name.maxLenght) {
          return `Enter from ${name.$params.minLength.min} to ${name.$params.maxLenght.max} characters`;
        } else if (!name.customValidator) {
          return "Document title is already used";
        }
      } else {
        return "";
      }
    },
    async uploadFile(event) {
      let [file] = event.target.files;
      if (file.size > 720 * 480) {
        event.preventDefault();
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The image cannot be larger than 2MB nor exceed 780x480px dimensions",
          icon: "flaticon-remove"
        });
        this.clearfile();
      } else {
        let fileData = FileService.generateResourceData(
          "/documents/covers",
          file.name
        );
        let queryString = FileService.buildQueryString(fileData);
        let urlFile = await FileService.uploadResource(file, queryString);
        if (urlFile) {
          this.imagePreview = URL.createObjectURL(file);
          this.document.images = [urlFile];
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The image cannot be larger than 2MB nor exceed 500x500px dimensions",
            icon: "flaticon-remove"
          });
        }
      }
    },
    clearfile() {
      this.imagePreview = null;
      this.document.images = [];
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    changeVersion(releaseType, lastVersion = "0.0.0") {
      const version = lastVersion.split(".").map(Number);
      if (releaseType === "MAJOR") {
        this.document.release.version = [(version[0] += 1), 0, 0].join(".");
      } else if (releaseType === "MEDIUM") {
        this.document.release.version = [version[0], (version[1] += 1), 0].join(
          "."
        );
      } else {
        this.document.release.version = [
          version[0],
          version[1],
          (version[2] += 1)
        ].join(".");
      }
    },
    getClassByDocumentStatus(status) {
      if (status === "DRAFT") {
        return "status-draft";
      } else if (status === "REVISION") {
        return "status-started";
      } else if (status === "APPROVED") {
        return "status-new";
      } else if (status === "PUBLISHED") {
        return "status-confirmed";
      }
    },
    getStatusFormat(status) {
      if (status === "DRAFT") {
        return "Draft";
      } else if (status === "REVISION") {
        return "In Revision";
      } else if (status === "APPROVED") {
        return "Approved";
      } else if (status === "PUBLISHED") {
        return "Published";
      } else {
        return "Unknown";
      }
    },
    getTypeFormat(type) {
      if (type === "GUIDE") {
        return "Guide";
      } else if (type === "RELEASE") {
        return "Release";
      } else if (type === "SUPPORT") {
        return "Support";
      }
    },
    getAppFormat(value) {
      let app = this.apps.find(app => app.value === value);
      if (app) {
        return app.name;
      } else {
        return "Unknown";
      }
    },
    getModuleFormat(value) {
      let module = this.modules.find(module => module.value === value);
      if (module) {
        return module.name;
      } else {
        return "Unknown";
      }
    },
    getTabByInvalidDocumentData(document) {
      let parameters =
        document.type.$invalid ||
        document.app.$invalid ||
        document.module.$invalid ||
        document.release.$invalid;
      let details =
        document.short_description.$invalid || document.title.$invalid;
      let status = document.status.$invalid;
      let images = document.images.$invalid;
      if (parameters || details || status || images) {
        return "Overview";
      } else {
        return "Content";
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async detectChanges(to, from, next) {
      let isEqual = lodash.isEqual(this.document, this.documentCopy);
      if (!isEqual && !this.onSave) {
        let { value, dismiss } = await Swal.fire({
          title: "Important",
          html:
            "The document has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveDocument(to.path);
        } else if (dismiss === Swal.DismissReason.cancel) {
          next();
        }
      } else {
        next();
      }
    },
    isInDocumentModule(modules = []) {
      if (!(modules.indexOf("document") > -1)) {
        this.setDocumentSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    async getLastReleaseByApp(app) {
      try {
        let { data } = await DocumentsAPI.getLastReleaseByApp(
          app,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    gotToDocument(document) {
      if (document.type === "RELEASE") {
        return `/help/release/${document.slug}`;
      } else {
        return `/help/${this.getSlugByValue(document.module)}/${document.slug}`;
      }
    },
    getAbsoluteUrl(document) {
      if (document.type === "RELEASE") {
        return `${this.getDomainByApp(document.app)}/help/release/${
          document.slug
        }`;
      } else {
        return `${this.getDomainByApp(document.app)}/help/${this.getSlugByValue(
          document.module
        )}/${document.slug}`;
      }
    },
    getSlugByValue(value) {
      if (value === "ACCOUNT") {
        return "account";
      } else if (value === "DRIVER") {
        return "driver";
      } else if (value === "AREAS") {
        return "areas";
      } else if (value === "CUSTOMERS") {
        return "customers";
      } else if (value === "DESTINATIONS") {
        return "destinations";
      } else if (value === "DOCUMENTATION") {
        return "documentation";
      } else if (value === "PARTNERS") {
        return "partners";
      } else if (value === "EXPERIENCES") {
        return "experiences";
      } else if (value === "GLOBAL") {
        return "global";
      } else if (value === "LOGS") {
        return "logs";
      } else if (value === "PROFILE") {
        return "profile";
      } else if (value === "RATES") {
        return "rates";
      } else if (value === "RESERVATIONS") {
        return "reservations";
      } else if (value === "SUPPLIERS") {
        return "suppliers";
      } else if (value === "TEAM") {
        return "team";
      } else if (value === "VEHICLES") {
        return "vehicles";
      } else if (value === "VEHICLES_GALLERY") {
        return "vehicles-gallery";
      } else if (value === "DASHBOARD") {
        return "dashboard";
      } else if (value === "RELEASE") {
        return "release";
      } else if (value === "GUIDE") {
        return "guide";
      } else if (value === "SUPPORT") {
        return "support";
      }
    },
    getDomainByApp(appId) {
      let appDetails = APPS.find(app => app.value === appId);
      if (appDetails) {
        return appDetails.url;
      } else {
        return null;
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The URL has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The URL couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    /**
     * Updates the document
     * If the document is being published and is of type RELEASE, it prompts the user for confirmation
     * before proceeding with the update.
     */
    async updateDocument() {
      const isPublishing =
        this.oldStatus === "APPROVED" && this.document.status === "PUBLISHED";
      if (isPublishing && this.document.type === "RELEASE") {
        let { value } = await Swal.fire({
          title: "Publish Release?",
          html:
            "Publishing this release will trigger popups in all apps and may cause the application to reload for users.",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          allowOutsideClick: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveDocument();
        }
      } else {
        this.saveDocument();
      }
    },
    /**
     * Converts a base64 data URL to a File object.
     * @param {string} dataUrl - The base64 data URL.
     * @param {string} filename - The desired filename for the File object.
     * @returns {File} - The resulting File object.
     */
    base64ToFile(dataUrl, filename) {
      const [meta, content] = dataUrl.split(",");
      const mime = meta.match(/:(.*?);/)[1];
      const bstr = atob(content);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) u8arr[n] = bstr.charCodeAt(n);
      return new File([u8arr], filename, { type: mime });
    },
    /**
     * Called when the editor is ready.
     * @param {Object} quill - The Quill editor instance.
     */
    onEditorReady(quill) {
      quill.on("text-change", (delta, oldDelta, source) => {
        if (source !== "user") return;
        const editor = quill.root;
        const images = editor.querySelectorAll("img");
        images.forEach(async img => {
          const src = img.getAttribute("src");
          if (src && src.startsWith("data:image")) {
            const file = this.base64ToFile(src, `image-${Date.now()}.png`);
            let fileData = FileService.generateResourceData(
              "/documents/covers",
              file.name
            );
            let queryString = FileService.buildQueryString(fileData);
            let urlFile = await FileService.uploadResource(file, queryString);
            if (urlFile) {
              img.setAttribute("src", urlFile);
            }
          }
        });
      });
    },
    ...mapActions(["getBranchsOptions"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setDocumentSearchCriteria"
    ])
  },
  components: {
    [Switch.name]: Switch,
    [Card.name]: Card,
    [DatePicker.name]: DatePicker,
    flatPicker,
    WSelect,
    VueEditor
  },
  computed: {
    ...mapGetters(["sesion", "sigout"])
  },
  beforeRouteLeave(to, from, next) {
    this.isInDocumentModule(to.meta.modules);
    this.detectChanges(to, from, next);
  },
  validations: {
    document: {
      title: {
        required,
        minLength: minLength(40),
        maxLenght: maxLength(160),
        customValidator: async function(value) {
          if (value.length >= 40 && value.length <= 160) {
            let slug = this.createSlug(value);
            if (this.lastSlug !== slug) {
              return slug && this.document.app
                ? await this.checkDocumentSlugIsDuplicate(
                    slug,
                    this.document.app
                  )
                : true;
            } else {
              return true;
            }
          } else {
            return false;
          }
        }
      },
      type: {
        required
      },
      app: {
        required
      },
      module: {
        required: requiredIf(function(value) {
          return this.document.type != "RELEASE";
        })
      },
      release: {
        type: {
          required: requiredIf(function(value) {
            return this.document.type === "RELEASE";
          })
        },
        version: {
          required: requiredIf(function(value) {
            return this.document.type === "RELEASE";
          })
        }
      },
      status: {
        required
      },
      images: {
        required,
        minLength: minLength(1),
        maxLenght: maxLength(8)
      },
      content: {
        required,
        minLength: minLength(200),
        maxLenght: maxLength(20000)
      },
      short_description: {
        required,
        minLength: minLength(50),
        maxLenght: maxLength(160)
      },
      slug: {
        required
      }
    }
  }
};
</script>
